import React from "react";
import { Button, Container } from "react-bootstrap";
import { NavigationBar } from "./NavigationBar";

const Login = ({login}) => {
    return (
        <>
             <NavigationBar />
             <Container>
                <div className="info-box">
                    <div>
                        <h3 className="text-color">Oops! We couldn't log you in automatically</h3>
                        <p className="text-color">Try to login using button below:</p>
                    </div>
                    <Button onClick={login} className="primary-color">Sign In</Button>
                    <div>
                        <p className="text-color alert-info">
                            If you get an error, please speak to your supervisor to be added to one of the required access group(s), and try again.
                        </p>
                    </div>
                </div>
                {/* <div className="logo-container">
                    <img 
                        src="https://emails.duke-energy.com/brand/logos/logo-de.png" 
                        alt="Duke Energy Logo"
                        height={50} />
                </div> */}
            </Container>
        </>
    );
};

export default Login;